import React, { useEffect, useState } from "react";

import AppLayout from "../components/AppLayout";
import Footer from "../components/Footer";

import "./RankingDaRodada.css";
import noGamesImg from "../assets/no-games.png";
import Spinner from "../components/Spinner";

function IndicatorBar({ value, percent, color }) {
  const largura = Math.min(Math.max(percent, 0), 100);

  return (
    <div className="indicator-bar" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <div
        className="indicator-track"
        style={{ background: "#222", borderRadius: "4px", overflow: "hidden", width: "100px", height: "8px" }}
      >
        <div
          className="indicator-fill"
          style={{ width: `${largura}%`, height: "100%", background: color, transition: "width 0.3s ease" }}
        />
      </div>
      <span className="indicator-value" style={{ minWidth: "40px", textAlign: "right" }}>
        {Math.round(value)}
      </span>
    </div>
  );
}

function ScoreBadge({ score }) {
  let colorClass = "score-muted";

  if (score >= 90) colorClass = "score-green";
  else if (score >= 85) colorClass = "score-green-dim";
  else if (score >= 80) colorClass = "score-orange";

  return <div className={`score-badge ${colorClass}`}>{score}</div>;
}

export default function RankingDaRodadaTeste() {
  const [ranking, setRanking] = useState([]);
  const [multipla05, setMultipla05] = useState([]);
  const [indicadorSelecionado, setIndicadorSelecionado] = useState(null);
  const [odds, setOdds] = useState({});
  const [teamsMap, setTeamsMap] = useState({});
  const [groupedLeagues, setGroupedLeagues] = useState({});
  const [selectedCountry, setSelectedCountry] = useState("all");
  const [selectedLeague, setSelectedLeague] = useState("all");
  const [showModal, setShowModal] = useState(false);
  const [activeMarket, setActiveMarket] = useState("goals");
  const [setPieceData, setSetPieceData] = useState({ cards: [], corners: [], cardsMap: {}, cornersMap: {} });

  function getScoreColor(jogo) {
    const meta = jogo.indicators?.metaDisplay || 0;
    const poisson = jogo.indicators?.poissonDisplay || 0;
    const media = jogo.indicators?.mediaDisplay || 0;
    const score = jogo.score || 0;

    if (score >= 80 && meta >= 80 && poisson >= 90 && media >= 75) return "azul";
    if (score >= 70 && meta >= 70 && poisson >= 80 && media >= 70) return "laranja";
    return "verde";
  }

  function ordenarRanking(indicador) {
    let ordenado;
    if (indicador === "metaMomentum") {
      ordenado = [...ranking].sort((a, b) => (b.indicators?.metaDisplay ?? 0) - (a.indicators?.metaDisplay ?? 0));
    } else if (indicador === "poissonMomentum") {
      ordenado = [...ranking].sort((a, b) => (b.indicators?.poissonDisplay ?? 0) - (a.indicators?.poissonDisplay ?? 0));
    } else if (indicador === "mediaSimples") {
      ordenado = [...ranking].sort((a, b) => (b.indicators?.mediaDisplay ?? 0) - (a.indicators?.mediaDisplay ?? 0));
    } else {
      ordenado = [...ranking].sort((a, b) => (b.score ?? 0) - (a.score ?? 0));
    }
    setRanking(ordenado);
  }

  function toggleIndicador(indicador) {
    if (indicadorSelecionado === indicador) {
      setIndicadorSelecionado(null);
      ordenarRanking("score");
    } else {
      setIndicadorSelecionado(indicador);
      ordenarRanking(indicador);
    }
  }

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        setShowModal(false);
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  async function fetchTeams() {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/teams`);
      const payload = await res.json();
      const data = Array.isArray(payload) ? payload : Array.isArray(payload?.data) ? payload.data : [];
      const map = {};
      data.forEach((t) => {
        if (t && t.bzzoiro_id) {
          map[t.bzzoiro_id] = t.team_name;
        }
      });
      setTeamsMap(map);
    } catch (err) {
      console.error("Erro ao carregar times:", err);
      setTeamsMap({});
    }
  }

  useEffect(() => {
    async function fetchGroupedLeagues() {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/leagues`);
        const data = await res.json();
        setGroupedLeagues(data);
      } catch (err) {
        console.error("Erro ao carregar ligas agrupadas:", err);
      }
    }
    fetchGroupedLeagues();
  }, []);

  useEffect(() => {
    async function fetchSetPieceStats() {
      try {
        const [cardsRes, cornersRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/stats/cards`),
          fetch(`${process.env.REACT_APP_API_URL}/stats/corners`),
        ]);

        const [cardsData, cornersData] = await Promise.all([
          cardsRes.ok ? cardsRes.json() : Promise.resolve({ matches: [] }),
          cornersRes.ok ? cornersRes.json() : Promise.resolve({ matches: [] }),
        ]);

        const cardsMap = {};
        (cardsData.matches || []).forEach((item) => {
          const homeId = item?.home_team_id ?? item?.home_team_name;
          const awayId = item?.away_team_id ?? item?.away_team_name;
          if (homeId && awayId) {
            cardsMap[`${homeId}|${awayId}`] = item;
          }
        });

        const cornersMap = {};
        (cornersData.matches || []).forEach((item) => {
          const homeId = item?.home_team_id ?? item?.home_team_name;
          const awayId = item?.away_team_id ?? item?.away_team_name;
          if (homeId && awayId) {
            cornersMap[`${homeId}|${awayId}`] = item;
          }
        });

        setSetPieceData({
          cards: cardsData.matches || [],
          corners: cornersData.matches || [],
          cardsMap,
          cornersMap,
        });
      } catch (err) {
        console.error("Erro ao carregar estatísticas de cartões e escanteios:", err);
      }
    }

    fetchSetPieceStats();
  }, []);

  useEffect(() => {
    async function fetchRanking() {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/indicators/expectativas`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        const data = await res.json();
        const jogosUnicos = [];
        const idsVistos = new Set();

        (data.jogos || []).forEach((jogo) => {
          const chave = `${jogo.home_team_id}-${jogo.away_team_id}`;
          if (!idsVistos.has(chave)) {
            idsVistos.add(chave);
            jogosUnicos.push(jogo);
          }
        });

        const filtrados = jogosUnicos.filter((jogo) => {
          const paisOk = selectedCountry === "all" || jogo.country_name === selectedCountry;
          const ligaOk = selectedLeague === "all" || jogo.league_id === Number(selectedLeague);
          return paisOk && ligaOk;
        });

        const ordenados = [...filtrados].sort((a, b) => b.score - a.score);

        const jogosComLiga = ordenados.map((jogo) => {
          let nomeLiga = "";
          if (groupedLeagues[jogo.country_name]) {
            const liga = groupedLeagues[jogo.country_name].find(
              (l) => Number(l.id) === Number(jogo.league_id)
            );
            nomeLiga = liga ? liga.name : "";
          }
          return { ...jogo, league_name: nomeLiga };
        });

        setRanking(jogosComLiga);
        setMultipla05(data.multipla05 ?? []);

        const oddsRequests = (ordenados || []).map(async (jogo) => {
          try {
            const resOdds = await fetch(
              `/api/v2/odds/?event_id=${jogo.event_id}&market=over_under_15&bookmaker_slug=betano`,
              { headers: { Authorization: `Token ${process.env.REACT_APP_BZZOIRO_API_KEY}` } }
            );

            if (!resOdds.ok) {
              return { matchId: jogo._id, overOdd: "-", underOdd: "-" };
            }

            let payload = {};
            try {
              payload = await resOdds.json();
            } catch (err) {
              return { matchId: jogo._id, overOdd: "-", underOdd: "-" };
            }

            const overOdd = payload.results?.find((r) => r.outcome === "over")?.decimal_odds ?? "-";
            const underOdd = payload.results?.find((r) => r.outcome === "under")?.decimal_odds ?? "-";
            return { matchId: jogo._id, overOdd, underOdd };
          } catch (err) {
            return { matchId: jogo._id, overOdd: "-", underOdd: "-" };
          }
        });

        const oddsResults = await Promise.all(oddsRequests);
        const oddsMap = {};
        oddsResults.forEach((o) => {
          oddsMap[o.matchId] = { over: o.overOdd, under: o.underOdd };
        });

        setOdds(oddsMap);
      } catch (err) {
        console.error("Erro ao carregar ranking:", err);
      }
    }

    fetchTeams();
    fetchRanking();
  }, [selectedCountry, selectedLeague, groupedLeagues]);

  function resolveTeamName(teamId, fallbackName, fallbackIdLabel) {
    if (teamId != null && teamId !== "" && teamId !== "null" && teamId !== "undefined") {
      const directName = teamsMap[teamId];
      if (directName) return directName;
      if (fallbackName) return fallbackName;
      return `Time ${teamId}`;
    }

    if (fallbackName) return fallbackName;
    if (fallbackIdLabel) return fallbackIdLabel;
    return "Time sem nome";
  }

  function getMatchLabel(jogo) {
    const home = resolveTeamName(jogo?.home_team_id, jogo?.home_team_name, "Casa");
    const away = resolveTeamName(jogo?.away_team_id, jogo?.away_team_name, "Visitante");
    if (home && away) return `${home} x ${away}`;
    if (jogo?.event_id) return `Partida #${jogo.event_id}`;
    return "Partida sem nome";
  }

  function getSetPieceTeamName(value, fallback) {
    if (!value || value === "null" || value === "undefined") return fallback;
    return value;
  }

  function getSetPieceMatchLabel(item) {
    const home = getSetPieceTeamName(item?.home_team_name, "Casa");
    const away = getSetPieceTeamName(item?.away_team_name, "Visitante");
    const fallbackLabel = `${home} x ${away}`;

    if (item?.home_team_name || item?.away_team_name) {
      return fallbackLabel;
    }

    if (item?.event_id) {
      return `Partida #${item.event_id}`;
    }

    return "Partida sem nome";
  }

  return (
    <AppLayout>
      <div className="ranking-container">
        <h1 className="ranking-header">Ranking da Rodada - Teste</h1>

        <div className="ranking-filtros">
          <select
            value={selectedCountry}
            onChange={(e) => {
              setSelectedCountry(e.target.value);
              setSelectedLeague("all");
            }}
          >
            <option value="all">Todos os Países</option>
            {Object.keys(groupedLeagues).map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>

          {selectedCountry !== "all" && (
            <select value={selectedLeague} onChange={(e) => setSelectedLeague(e.target.value)}>
              <option value="all">Todas as Ligas ({selectedCountry})</option>
              {groupedLeagues[selectedCountry]?.map((liga) => (
                <option key={liga.id} value={liga.id}>
                  {liga.name}
                </option>
              ))}
            </select>
          )}
        </div>

        <div className="indicadores">
          <button className={activeMarket === "goals" ? "ativo" : "inativo"} onClick={() => setActiveMarket("goals")}>
            Gols
          </button>
          <button className={activeMarket === "cards" ? "ativo" : "inativo"} onClick={() => setActiveMarket("cards")}>
            Cartões
          </button>
          <button className={activeMarket === "corners" ? "ativo" : "inativo"} onClick={() => setActiveMarket("corners")}>
            Escanteios
          </button>
        </div>

        {activeMarket !== "goals" && (
          <div className="ranking-info" style={{ marginBottom: "16px" }}>
            <strong>{activeMarket === "cards" ? "Cartões" : "Escanteios"} vindos da rota interna do backend</strong>
          </div>
        )}

        {activeMarket === "cards" && (
          <div className="multiplas" style={{ marginBottom: "24px" }}>
            <h2 className="multiplas-title">Cartões</h2>
            <div className="multiplas-list">
              {(setPieceData.cards || []).slice(0, 5).map((item, idx) => (
                <div className="multipla-item" key={item.event_id || idx}>
                  <div className="multipla-match-wrap">
                    <div className="multipla-match-header">Partida</div>
                    <div className="multipla-match">{getSetPieceMatchLabel(item)}</div>
                  </div>
                  <div className="multipla-score">
                    <span>Média:</span> <strong>{item.indicators?.avg_cards_90 ?? 0}</strong>
                  </div>
                  <div className="multipla-score">
                    <span>Risco:</span> <strong>{item.indicators?.risk_index ?? 0}%</strong>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeMarket === "corners" && (
          <div className="multiplas" style={{ marginBottom: "24px" }}>
            <h2 className="multiplas-title">Escanteios</h2>
            <div className="multiplas-list">
              {(setPieceData.corners || []).slice(0, 5).map((item, idx) => (
                <div className="multipla-item" key={item.event_id || idx}>
                  <div className="multipla-match-wrap">
                    <div className="multipla-match-header">Partida</div>
                    <div className="multipla-match">{getSetPieceMatchLabel(item)}</div>
                  </div>
                  <div className="multipla-score">
                    <span>Média:</span> <strong>{item.indicators?.avg_corners_90 ?? 0}</strong>
                  </div>
                  <div className="multipla-score">
                    <span>Diff:</span> <strong>{item.indicators?.corner_diff ?? 0}</strong>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {ranking.length > 0 ? (
          <table className="ranking-tabela">
            <thead>
              <tr>
                <th>#</th>
                <th>Jogo</th>
                <th>MetaMomentum</th>
                <th>PoissonMomentum</th>
                <th>Média Simples</th>
                <th>Cartões /90</th>
                <th>Escanteios /90</th>
                <th>SP Score</th>
              </tr>
            </thead>
            <tbody>
              {ranking.map((jogo, index) => {
                const homeKey = jogo?.home_team_id ?? teamsMap[jogo?.home_team_id] ?? jogo?.home_team_name ?? "home";
                const awayKey = jogo?.away_team_id ?? teamsMap[jogo?.away_team_id] ?? jogo?.away_team_name ?? "away";
                const cardsMetric = setPieceData.cardsMap?.[`${homeKey}|${awayKey}`]?.indicators?.avg_cards_90;
                const cornersMetric = setPieceData.cornersMap?.[`${homeKey}|${awayKey}`]?.indicators?.avg_corners_90;

                return (
                  <tr key={jogo._id || index}>
                    <td>{index + 1}</td>
                    <td className="jogo-coluna">
                      <div className="escudos">
                        <img src={`https://sports.bzzoiro.com/img/team/${jogo.home_team_id}/`} alt={teamsMap[jogo.home_team_id] || "Home"} className="escudo" />
                        <img src={`https://sports.bzzoiro.com/img/team/${jogo.away_team_id}/`} alt={teamsMap[jogo.away_team_id] || "Away"} className="escudo" />
                      </div>
                      <div className="detalhes">
                        <span className="confronto">{getMatchLabel(jogo)}</span>
                        <span className="data-hora">
                          {new Date(jogo.event_date).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}{" "}
                          {new Date(jogo.event_date).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" })}
                        </span>
                        <span className="odd-mini">
                          Over 1.5 = {odds[jogo._id]?.over ?? "-"} | Under 1.5 = {odds[jogo._id]?.under ?? "-"}
                        </span>
                        <div className="liga-nome">{jogo.league_name}</div>
                      </div>
                    </td>
                    <td>
                      <div className="barra azul">
                        <span>{Number(jogo.indicators?.metaDisplay ?? 0).toFixed(0)}</span>
                      </div>
                    </td>
                    <td>
                      <div className="barra verde">
                        <span>{Number(jogo.indicators?.poissonDisplay ?? 0).toFixed(0)}</span>
                      </div>
                    </td>
                    <td>
                      <div className="barra laranja">
                        <span>{Number(jogo.indicators?.mediaDisplay ?? 0).toFixed(0)}</span>
                      </div>
                    </td>
                    <td className="set-piece-metric">
                      <span>{cardsMetric !== undefined && cardsMetric !== null ? Number(cardsMetric).toFixed(1) : "-"}</span>
                    </td>
                    <td className="set-piece-metric">
                      <span>{cornersMetric !== undefined && cornersMetric !== null ? Number(cornersMetric).toFixed(1) : "-"}</span>
                    </td>
                    <td>
                      <div className={`score-circulo ${getScoreColor(jogo)}`}>
                        <span>{Number(jogo.score ?? 0).toFixed(0)}</span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div className="no-games">
            <img src={noGamesImg} alt="Sem jogos disponíveis" className="no-games-img" />
            <p>Sem jogos disponíveis no momento.</p>
          </div>
        )}

        {showModal && (
          <div className="modal-overlay" onClick={() => setShowModal(false)}>
            <div className="modal-box" onClick={(e) => e.stopPropagation()}>
              <h3>Detalhes da rodada</h3>
              <div className="modal-body">
                <p>Você pode testar as métricas e comparações aqui.</p>
                <p>Multipla 05: {multipla05.length}</p>
              </div>
              <button onClick={() => setShowModal(false)}>Fechar</button>
            </div>
          </div>
        )}

        <Footer />
      </div>
    </AppLayout>
  );
}
